import {
  matchPath,
  useLocation,
} from 'react-router-dom';
import classNames from 'classnames';

import { Link } from '@ui/Link';
import { getPathWithoutLang } from '@utils/i18n';

import s from './HeaderFastLinks.sss';

export interface FastLink {
  icon: React.FC<React.SVGProps<SVGAElement>>,
  counter?: number | null,
  indicator?: boolean,
  href?: string,
  onClick?: () => void,
}

export interface Props {
  fastLinks: FastLink[],
}

export const HeaderFastLinks: React.FC<Props> = ({
  fastLinks,
}) => {
  const location = useLocation();

  return (
    <ul className={s.list}>
      {fastLinks.map(({
        onClick,
        href,
        icon: Icon,
        counter,
        indicator,
      }, i) => {
        const match = href ? matchPath(location.pathname, getPathWithoutLang(href)) : false;

        return (
          <li
            key={i}
            className={s.item}
          >
            <Link
              className={classNames(s.link, {
                [s.linkStateActive]: match,
              })}
              theme='black'
              href={href}
              onClick={onClick}
            >
              <Icon
                className={s.icon}
                width="24"
                height="24"
              />

              {!!counter && (
                <span className={s.counter}>
                  {counter}
                </span>
              )}

              {indicator && (
                <span className={s.indicator} />
              )}
            </Link>
          </li>
        );
      })}
    </ul>
  );
};
